import React, { useEffect, useState } from "react";
import { redirect, useNavigate } from "react-router-dom";

import AdsBanner, { BannerPosition } from "@components/ads-banner/ads-banner";
import CourseComplete from "@components/course-сomplete/course-complete";
import WrapperAdsBanner from "@components/wrapper-ads-banner/WrapperAdsBanner";

import { useAppDispatch } from "@hooks/use-store";
import { setIsAdsScriptsReloaded } from "@store/app/app.slice";
import { formatUrlWithLocale } from "@helpers/format-url-with-locale";
import { normalizeLanguageCode } from "@helpers/helpers";
import { ExerciseCompleteData } from "@typings/global.types";

import { useGetExerciseEntrypointQuery } from "../../api/exercise-entrypoint";

function WrapperCourseComplete() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const { data } = useGetExerciseEntrypointQuery({
    exerciseId: 0,
  });

  //   const courseLanguage = normalizeLanguageCode(data?.user.courseLanguage);
  const courseLanguage = window.reactApp.locale.slice(0, 2);
  const certPrice = data?.user.prices.course_cert;
  const userId = data?.user.id;
  const modalDateShownKey = `dateModalShown_${userId}`;

  const [courseCompleteData, setCourseCompleteData] =
    useState<ExerciseCompleteData | null>(null);

  // Закриваємо компонент і онуляємо дані
  const closeResult = () => {
    // lessonsRefetch(); // TODO: оновити кеш уроків
    navigate(formatUrlWithLocale("/typing-tutor/")); // TODO: направити на тест
  };

  useEffect(() => {
    const sessionStorageData = window.sessionStorage.getItem(
      "exerciseCompleteData",
    );

    if (sessionStorageData && JSON.parse(sessionStorageData).lastCourse) {
      setCourseCompleteData(JSON.parse(sessionStorageData));
    } else {
      navigate(formatUrlWithLocale("/typing-tutor/"));
    }
  }, [navigate]);

  useEffect(() => {
    dispatch(setIsAdsScriptsReloaded(true));
  }, [dispatch]);

  const [typingTestUrl, setTypingTestUrl] = useState<string>("#");
  useEffect(() => {
    if (courseCompleteData?.lastCourse) {
      const { language } = courseCompleteData.lastCourse;
      setTypingTestUrl(formatUrlWithLocale(`/typing-test/${language}/`));
    }
  }, [courseCompleteData]);

  useEffect(() => {
    if (courseCompleteData?.courseImg !== undefined) {
      const nowDate = new Date();
      // Записати поточну дату в localStorage при завантаженні компонента для показу модалки через 24 години
      if (!courseCompleteData?.courseImg) {
        localStorage.setItem(modalDateShownKey, nowDate.toISOString());
      }
    }
  }, [courseCompleteData?.courseImg, modalDateShownKey]);

  if (!courseCompleteData?.lastCourse) {
    return null;
  }

  return (
    <div className='flex flex-col-reverse md:flex-col'>
      <div className='mb-2 min-h-[110px] md:mb-2'>
        <WrapperAdsBanner page='result'>
          <AdsBanner bannerPosition={BannerPosition.RESULT} />
        </WrapperAdsBanner>
      </div>
      <CourseComplete
        closeCourse={closeResult}
        courseTitle={courseCompleteData?.lastCourse.layoutName}
        courseName={courseCompleteData.lastCourse.language}
        typingTestUrl={typingTestUrl}
        courseLanguage={courseLanguage}
        certPrice={certPrice || "5$"}
        hasCourseCert={courseCompleteData.courseImg}
      />
    </div>
  );
}

export default WrapperCourseComplete;
